<template>
  <div
    class="zj-layout-main-content bgcolor scrollable"
    style="overflow: auto;"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="110px"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">值班导入</div>
        </zj-layout-header>
      </zj-layout-container>
      <el-form-item label="导入值班表" >
        <el-upload
          class="upload-demo"
          action=""
          :auto-upload="false"
          accept=".xlsx,.xls"
          :on-change="uploadAvatar"
          :before-upload="beforeAvatarUpload"
          :file-list="fileList">
          <el-button type="primary">上传文件<i class="el-icon-upload el-icon--right"></i></el-button>
          <div slot="tip" class="el-upload__tip">只能上传excel文件</div>
        </el-upload>
      </el-form-item>
      <div v-for="(value,key) in showList" :key="key">
        <div class="middleTitle">{{key}}</div>
        <el-form-item :label="item.role" v-for="(item,index) in value"  :key="index">
          <el-input
            v-model="item.name"
            style="width:40rem;"
            placeholder="请输入姓名"
            disabled
          ></el-input>
          <el-input
            v-model="item.phone"
            style="width:40rem;margin-left:1.5rem;"
            placeholder="请输入联系电话"
            disabled
         ></el-input>
       </el-form-item>
      </div>
      <el-form-item class="right" style="width:134rem;">
        <el-button
          type="primary"
          @click="save()"
          v-if="isShow"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { importExcel,saveduty } from '../../../../../request/msgApi';
export default {
  name: "addduty",
  controller: "UI",
  action: "addduty",
  data() {
    return {
      peopleList:[],
      showList:{},
      isShow:true
    };
  },
  created: function() {
  },
  mounted: function() {},
  methods: {
    beforeAvatarUpload(file){
      console.log('file')
      console.log(file)
    },
    uploadAvatar(item) {
      // console.log(item)
      let that=this;
      const fileObj = item.raw;
      const form = new FormData();
      form.append('file', fileObj);
      importExcel(form).then(res=>{
        that.peopleList = res.data;
        let data = res.data;
        let dataObj={}
        data.forEach(item=>{
          if(dataObj.hasOwnProperty(item.location)){
            dataObj[item.location].push(item)
          }else{
            dataObj[item.location]=[];
            dataObj[item.location].push(item)
          }
          
        })
        that.showList = dataObj;
      })
      this.fileList = []
    },
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    save() {
      let that=this;
      if(this.peopleList.length==0){
         that.errmsg("请先上传数据")
         return
      }
      let params={
           "list":this.peopleList
         }
      saveduty(params).then(res=>{
        console.log("保存数据")
        console.log(res)
        if(res.code==0){
          that.$message({
            message: '保存成功',
            type: 'success'
          });
          that.isShow=false;
        }else{
          that.errmsg(res.msg)
          that.isShow=true;
        }
      })
    },
  
  }
};
</script>
<style type="text/css">
.middleTitle{
  width: 110px;
  text-align: right;
  font-size: 14px;
  margin-bottom: 10px;

}
</style>
